import { DateTimeUtils } from '@locus-taxy/encore-utils';

export type TimezoneOption = {
  value: string;
  label: string;
};

export function getTimezoneOptionLabel(
  option: TimezoneOption | string
): string {
  return typeof option === 'string' ? option : option.label;
}

export function normalizeTimezoneChangeValue(
  newValue: string | TimezoneOption | (string | TimezoneOption)[] | null
): string | null {
  const value = Array.isArray(newValue) ? newValue[0] : newValue;
  if (!value) {
    return null;
  }

  return typeof value === 'string' ? value : value.value;
}

export function getNextTimezone(
  currentTimezone: string,
  newValue: string | TimezoneOption | (string | TimezoneOption)[] | null
): string | null {
  const timezoneValue = normalizeTimezoneChangeValue(newValue);
  if (!timezoneValue || timezoneValue === currentTimezone) {
    return null;
  }
  return timezoneValue;
}

export function normalizeLocaleChangeValue(
  newValue: string | string[] | null
): string | null {
  const value = Array.isArray(newValue) ? newValue[0] : newValue;
  return value ?? null;
}

export function buildTimezoneOptionsWithOffset(
  timezoneOptions: string[],
  timezone: string
): TimezoneOption[] {
  const dateTimeUtils = DateTimeUtils.getInstance();
  const hasCurrentTimezone = timezoneOptions.includes(timezone);

  let options: string[] = [];
  if (timezoneOptions.length === 0) {
    options = [timezone];
  } else if (hasCurrentTimezone) {
    options = timezoneOptions;
  } else {
    options = [...timezoneOptions, timezone];
  }

  return options.map(tz => {
    const offset = dateTimeUtils.getTimezoneOffset(tz);
    return {
      value: tz,
      label: `${tz} (${offset})`,
    };
  });
}

export function isTimezoneOptionEqualToValue(
  opt: TimezoneOption | string,
  val: TimezoneOption | string
): boolean {
  const optValue = typeof opt === 'string' ? opt : opt.value;
  const valValue = typeof val === 'string' ? val : val.value;
  return optValue === valValue;
}
